import {Suspense} from 'react';
import {Outlet, createRoute, redirect} from '@tanstack/react-router';
import Cookies from 'universal-cookie';
import {APP_HOME, RECOVER_PASSWORD} from '@/anonymous/routing/paths';
import {LOGIN} from '@/anonymous/routing/paths';
import AnonymousLayout from '@/shared/components/layout/AnonymousLayout';
import RouteElementSkeleton from '@/shared/components/ui/skeletons/RouteElementSkeleton';
import {REDIRECT_TO} from '@/shared/const/cookies';
import {AppRouterContext} from '@/shared/routing';
import {USER_HOME} from '@/shared/routing/paths';
import {Route as rootRoute} from '../__root';

function AnonymousRoutesLayoutComponent() {
  return (
    <AnonymousLayout>
      <Suspense fallback={<RouteElementSkeleton />}>
        <Outlet />
      </Suspense>
    </AnonymousLayout>
  );
}

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: APP_HOME,
  component: AnonymousRoutesLayoutComponent,
  beforeLoad: function ({
    context,
    location
  }: {
    context: AppRouterContext;
    location: {pathname: string};
  }) {
    if (location.pathname === APP_HOME && !context.isLoggedIn) {
      throw redirect({to: LOGIN, replace: true});
    }
    if (context.isLoggedIn && location.pathname !== RECOVER_PASSWORD) {
      const cookies = new Cookies();
      let redirectTo = cookies.get(REDIRECT_TO) ?? USER_HOME;

      if (redirectTo === LOGIN) {
        redirectTo = USER_HOME;
      }

      throw redirect({to: redirectTo, replace: true});
    }
  }
});
